module.exports = __webpack_public_path__ + "assets/2-Atlanta-Best-Tech-Sales-Careers.2a1c10d0.png";